var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"QHfileList"},_vm._l((_vm.values),function(item,index){return _c('div',{key:index,staticClass:"li"},[_c('p',[_vm._v(_vm._s(item.name))]),_c('span',{staticClass:"tool flex-center"},[_c('font',{on:{"click":function($event){_vm.$QHopen.url(_vm.$httpFile(item.url),1500)}}},[_vm._v("查看")])],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }